import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
    FaWhatsapp
  } from "react-icons/fa";
import "./Earn.css";
import TrackApi from "../../Activity_Track/TrackApi";
import { useCookies } from "react-cookie";

function Earn() {
    const [mobile, setmobile] = useState('');
    const [cookies, setCookie] = useCookies(['LeadId']);


    const handlemobile = event => {
        const re = /^[0-9\b]+$/;
        if (event.target.value.length < 11 && re.test(event.target.value)) {
            setmobile(event.target.value);
        }
        if (event.target.value.length == 0) {
            setmobile("");
        }  
    };

    const trackData=(id)=>{
      const payloadData={
        "RelatedProspectId":id,
        "ActivityNote": "Your home Note",
        "mx_Custom_1": "Refer Earn",
        "mx_Custom_2": "",
        "mx_CustomObject_81":window.location.href
       }
       TrackApi(payloadData);
    }
    useEffect(()=>{
    
  if(cookies && cookies.RelatedProspectId){
    trackData(cookies.RelatedProspectId);
  }
      
    },[])
    return(
        <> 
        <div className="compInfoMain">
            <div className="textErrorDiv">Uh Oh! 404</div>
            <h1>Page Not Found</h1>
            <a href="/">Go to Home Page</a>
          </div> 
        {/* <div className="refer-bg">
            <section className="refer-earn-sc">
                <Container>
                    <Row>
                        <Col xs={12}>
                            <div className="section-header">
                                <h2>Refer and Earn</h2>
                                <p>Refer "Moneysukh" to your friends and earn exciting rewards!</p>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="refer-list">
                                <p>Your friends get</p>
                                <ul>
                                   
                                    <li>Free Demat account opening in 10 minutes</li>
                                    <li>Trade as low as Rs 10 per order.</li>
                                   
                                </ul>
                            </div>    
                        </Col>
                    </Row> 
                    <Row>
                        <Col>
                            <div className="refer-form">
                                <h5>Enter your mobile number to get referral link</h5>
                               
                                <input type="text"  placeholder="Enter Mobile Number" value={mobile} onChange={handlemobile} name="name" autoComplete="off" />
                                <a href="">Get Link</a>
                                <div className="refer-code">
                                    <input type="text" placeholder="Your Referal Code"></input>
                                    <a href="" >Copy</a>
                                    <a href="" className="whatsapp-icon"><span><FaWhatsapp /></span> Share</a>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div> */}
        </>
    )
}

export default Earn;